import api from "./index";

// Get all Twilio accounts
export const getAllTwilioAccounts = () => api.get("api/ai-voice-caller/twilio-integerations/");

// Get a specific Twilio account
export const getTwilioAccount = (id) => api.get(`api/ai-voice-caller/twilio-integerations/${id}/`);

// Create a new Twilio account
export const createTwilioAccount = (data) => api.post("api/ai-voice-caller/twilio-integerations/", data);

// Update a Twilio account
export const updateTwilioAccount = (id, data) => api.put(`api/ai-voice-caller/twilio-integerations/${id}/`, data);

// Delete a Twilio account
export const deleteTwilioAccount = (id) => api.delete(`api/ai-voice-caller/twilio-integerations/${id}/`);

// Test a specific Twilio account connection
export const testTwilioAccountConnection = (id) => {
  // The backend API might not have a specific test endpoint yet
  // For now, we'll just get the account details to verify it exists
  return api.get(`api/ai-voice-caller/twilio-integerations/${id}/`);
};

// Legacy API endpoints (kept for backward compatibility)
// Get Twilio settings (single account) - now returns all accounts
export const getTwilioSettings = () => api.get("api/ai-voice-caller/twilio-integerations/");

// Update Twilio settings (single account) - now updates a specific account
// Note: This assumes account ID 1 is the primary account
export const updateTwilioSettings = (data) => {
  // Format the data to match the new API structure
  const formattedData = {
    account_sid: data.accountSid || data.account_sid,
    auth_token: data.authToken || data.auth_token,
    phone_number: data.phoneNumber || data.phone_number,
    is_active: data.isActive !== undefined ? data.isActive : (data.is_active !== undefined ? data.is_active : true)
  };
  return api.put("api/ai-voice-caller/twilio-integerations/1/", formattedData);
};

// Test Twilio connection (single account) - now verifies a specific account
// Note: This assumes account ID 1 is the primary account
export const testTwilioConnection = () => {
  // The backend API might not have a specific test endpoint yet
  // For now, we'll just get the account details to verify it exists
  return api.get("api/ai-voice-caller/twilio-integerations/1/");
};